import React, { useState } from "react";

export const useFileAttachment = () => {
    const [attachedFile, setAttachedFile] = useState<File | null>(null);
    const [attachedImages, setAttachedImages] = useState<File[]>([]);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];

            // Check both extension and MIME type
            const isTxt =
                file.name.toLowerCase().endsWith(".txt") &&
                (file.type === "text/plain" || file.type === "");

            if (!isTxt) {
                alert("Only .txt files are allowed");
                e.target.value = ""; // clear invalid file
                return;
            }

            setAttachedFile(file);
            setAttachedImages([]);
            e.target.value = ""; // reset to allow same file selection again
        }
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const files = Array.from(e.target.files);
            const hasInvalidFile = files.some((file) => !file.type.startsWith("image/"));
            if (hasInvalidFile) {
                alert("Only image files are allowed");
                e.target.value = "";
                return;
            }

            setAttachedImages((prev) => [...prev, ...files]);
            setAttachedFile(null);
            e.target.value = "";
        }
    };

    const removeFile = () => {
        setAttachedFile(null);
        setAttachedImages([]);
    };

    const removeImageAt = (indexToRemove: number) => {
        setAttachedImages((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    const readFileAsText = (file: File): Promise<string> => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsText(file);
        });
    };

    return {
        attachedFile,
        attachedImages,
        handleFileChange,
        handleImageChange,
        removeFile,
        removeImageAt,
        readFileAsText,
        setAttachedFile,
        setAttachedImages,
    };
};
